import {
  LocalFireDepartment,
  AccessTimeOutlined,
  MoneyOffOutlined,
  WeekendOutlined,
  ChairOutlined,
  NewReleasesOutlined,
  AutoAwesomeOutlined,
  PeopleAltOutlined,
  PersonOutlined,
  ApartmentOutlined,
  StorefrontOutlined,
  LocalOfferOutlined,
  LoginOutlined,
  AccountBalanceOutlined,
  PetsOutlined,
} from '@mui/icons-material'

export const specialIconMap: Record<string, React.ReactNode> = {
  'Resales Unit': <StorefrontOutlined />, // ขายดาวน์
  'Urgent Sale': <AccessTimeOutlined />, // ขายด่วน
  'Break Downpayment': <MoneyOffOutlined />, // หลุดดาวน์
  'Fully Furnished': <WeekendOutlined />, // เฟอร์ครบ
  'Partly Finiushed': <ChairOutlined />, // เฟอร์บางส่วน
  'Brand New': <NewReleasesOutlined />, // ใหม่เอี่ยม
  'New Decorate': <AutoAwesomeOutlined />, // ตกแต่งใหม่
  'Sale With Tenant': <PeopleAltOutlined />, // ขายพร้อมผู้เช่า
  'Sale By Owner': <PersonOutlined />, // ขายโดยเจ้าของ
  'Unit From Developer': <ApartmentOutlined />, // ขายโดยโครงการ
  'Presales Project': <StorefrontOutlined />, // พรีเซลล์ โครงการ
  'Cheap Price': <LocalOfferOutlined />, // ราคาถูก
  'Move in Ready': <LoginOutlined />, // พร้อมอยู่
  'Bank Asset': <AccountBalanceOutlined />, // ทรัพย์ธนาคาร
  'Pet Allowed': <PetsOutlined />, // เลี้ยงสัตว์ได้
}
